import React from 'react';
import _ from 'lodash';
import {FormErrorMessage} from '../../../ui-toolkit/forms/form-features/FormErrorMessage';

function PrimitiveFormatter({entity}) {
    if (typeof entity != 'string' && entity % 1 != 0 && entity != null) {
        return entity.toLocaleString();
    }
    if (_.isObject(entity)) {
        return <FormErrorMessage>{JSON.stringify(entity)}</FormErrorMessage>;
    }
    if (entity === 0) {
        return 0;
    }
    return entity || '-';
}

export default PrimitiveFormatter;
